<template>
<div>
    <Breadcrumbs main="Sales" title="Challan Details" />

    <!-- Container-fluid starts-->
    <div class="container-fluid">

        <!-- Back Button -->
        <div
            style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;"
        >
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div>
            </b-button>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <px-card>

                    <div slot="with-padding">

                        <div class="form theme-form">

                            <!-- Basic Info -->
                            <div class="row">

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Challan ID</label>

                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="detail?.challan_id || 'N/A'"
                                            disabled
                                        >
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Delivery Status</label>

                                        <input
                                            class="form-control text-capitalize"
                                            type="text"
                                            :value="detail?.delivery_status || 'N/A'"
                                            disabled
                                        >
                                    </div>
                                </div>

                            </div>

                            <!-- Client & Company -->
                            <div class="row">

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Client Name</label>

                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="detail?.client?.user_name || 'N/A'"
                                            disabled
                                        >
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Company</label>

                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="detail?.client?.additional_info?.company?.name || 'N/A'"
                                            disabled
                                        >
                                    </div>
                                </div>

                            </div>

                            <!-- Order & Invoice -->
                            <div class="row">

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Order ID</label>

                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="detail?.order?.order_id || 'N/A'"
                                            disabled
                                        >
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Invoice ID</label>

                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="detail?.invoice?.invoice_id || 'N/A'"
                                            disabled
                                        >
                                    </div>
                                </div>

                            </div>

                            <!-- Amount -->
                            <div class="row">

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Total Amount</label>

                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="detail?.invoice?.total || 0"
                                            disabled
                                        >
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Paid Amount</label>

                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="detail?.invoice?.paid_amount || 0"
                                            disabled
                                        >
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Due Amount</label>

                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="detail?.invoice?.due_amount || 0"
                                            disabled
                                        >
                                    </div>
                                </div>

                            </div>

                            <!-- Delivery -->
                            <div class="row">

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Delivery Date</label>

                                        <input
                                            class="form-control"
                                            type="date"
                                            :value="detail?.delivery_date || ''"
                                            disabled
                                        >
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Delivery Address</label>

                                        <input
                                            class="form-control"
                                            type="text"
                                            :value="detail?.delivery_address || 'N/A'"
                                            disabled
                                        >
                                    </div>
                                </div>

                            </div>

                            <!-- Remarks -->
                            <div class="row">

                                <div class="col">
                                    <div class="form-group">
                                        <label>Remarks</label>

                                        <textarea
                                            class="form-control"
                                            rows="3"
                                            :value="detail?.remarks || 'N/A'"
                                            disabled
                                        ></textarea>
                                    </div>
                                </div>

                            </div>

                            <!-- Products -->
                            <div class="row mt-4">

                                <div class="col-12">
                                    <h5>Challan Products</h5>

                                    <div class="table-responsive">

                                        <table class="table table-bordered">

                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Product</th>
                                                    <th>Ordered Qty</th>
                                                    <th>Delivered Qty</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                <tr
                                                    v-for="(item, index) in detail?.challan_products || []"
                                                    :key="item.id"
                                                >
                                                    <td>
                                                        {{ index + 1 }}
                                                    </td>

                                                    <td>
                                                        {{ item?.product?.name || 'N/A' }}
                                                    </td>

                                                    <td>
                                                        {{ item?.ordered_quantity || 0 }}
                                                    </td>

                                                    <td>
                                                        {{ item?.delivered_quantity || 0 }}
                                                    </td>

                                                    <td>
                                                        {{ item?.line_total || 0 }}
                                                    </td>
                                                </tr>

                                                <tr
                                                    v-if="!detail?.challan_products?.length"
                                                >
                                                    <td colspan="5" class="text-center">
                                                        No Products Found
                                                    </td>
                                                </tr>

                                            </tbody>

                                        </table>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </px-card>
            </div>
        </div>

    </div>
    <!-- Container-fluid Ends-->

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
    computed
} from "vue";
import ItemTable from "../items-table/edit-item-table.vue";
import moment from "moment";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {
    toWords
} from 'number-to-words'
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        'v-select': vSelect
    },

    data() {
        return {
           
        };
    },

    computed: {
        ...mapState({
            detail: state => state.order.challan_detail,
           
        })
    },

    mounted() {
        this.$store.dispatch("order/fetchChallanDetail", this.$route.params.id)
        
    },

    watch: {
        detail(oldValue, newValue) {
         
           
        },

    },

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },
        
    
    }
};
</script>

<style scoped>
.order-card {
    border-radius: 16px;
    padding: 10px 8px;
    background: linear-gradient(145deg, #ffffff, #f8f9fa);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
    transition: all 0.25s ease;
}

.order-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
}

/* Avatar */
.avatar {
    width: 45px;
    height: 45px;
    background: #4f46e5;
    color: white;
    font-weight: bold;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Fulfillment box */
.fulfillment-box {
    background: #f9fafb;
    border-radius: 12px;
}

/* Stats */
.stat-box {
    background: #ffffff;
    border-radius: 12px;
    padding: 15px;
    transition: 0.2s;
    border: 1px solid #f1f1f1;
}

.stat-box:hover {
    transform: scale(1.03);
}

.stat-icon {
    font-size: 20px;
    margin-bottom: 5px;
}

.stat-value {
    font-size: 20px;
    font-weight: 600;
}
</style>
